/**
 * SmartKick LIVE SCORES — standalone variant.
 *
 * Activated when REACT_APP_VARIANT=scores at build time, or in preview
 * via the URL query `?variant=scores`.
 *
 * Mounts the shared `ScoresRoutes` at root (basePath=""). The same
 * component is reused inside the main SmartKick app under
 * `/live-scores/*` (basePath="/live-scores").
 */
import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import ScoresRoutes from './scores/ScoresRoutes';
import { bootstrapAnalytics } from './utils/analytics';
import { initLiveActivities } from './scores/liveActivities';
import './scores/theme.css';

const ScoresApp = () => {
  // Track Live Scores app installs / sessions (tagged app='scores').
  useEffect(() => { bootstrapAnalytics(); }, []);
  // Wire the iOS Live Activity push-token listener (no-op off iOS).
  useEffect(() => { initLiveActivities(); }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScoresRoutes basePath="" />
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default ScoresApp;
